import React from "react";
import Navbar from "../components/Navbar";
import Sidebar from "../components/Sidebar";

function AssignedPlots() {
  const plots = [
    {
      id: 1,
      plotNo: "S253",
      owner: "Ramesh Kumar",
      status: "Active"
    },
    {
      id: 2,
      plotNo: "F412",
      owner: "Priya Agarwal",
      status: "Due"
    }
  ];

  return (
    <div>
      <Navbar />
      <Sidebar />

      <div
        style={{
          marginLeft: "240px",
          padding: "20px",
          paddingTop: "100px"
        }}
      >
        <h1>Assigned Plots</h1>

        {plots.map((plot) => (
          <div
            key={plot.id}
            style={{
              background: "#fff",
              padding: "15px",
              marginBottom: "15px",
              borderRadius: "10px"
            }}
          >
            <h3>{plot.plotNo}</h3>
            <p>{plot.owner}</p>
            <p>{plot.status}</p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default AssignedPlots;